import { ColumnTypes } from '@/components';

import { TFunction } from 'i18next';

export const getColumns = (t: TFunction<'common'>): ColumnTypes => [
	{
		title: 'NO.',
		dataIndex: 'no',
		key: 'no',
		align: 'center',
		width: 70,
	},
	{
		title: '국가',
		dataIndex: 'nationalName',
		key: 'nationalName',
		align: 'center',
	},
	{
		title: '구분',
		dataIndex: 'typeName',
		key: 'typeName',
		align: 'center',
		render: (value) => <p>{t(value)}</p>,
	},
	{
		title: '사업체',
		dataIndex: 'name',
		key: 'name',
		align: 'center',
	},
	{
		title: '사업체 전화번호',
		dataIndex: 'phone',
		key: 'phone',
		align: 'center',
	},
	{
		title: '사업체 주소',
		dataIndex: 'addressDetail',
		key: 'addressDetail',
		align: 'center',
	},
	{
		title: '등록자',
		dataIndex: 'registName',
		key: 'registName',
		align: 'center',
	},
	{
		title: '등록일',
		dataIndex: 'registDt',
		key: 'registDt',
		align: 'center',
	},
];

export const SearchType = {
	UNIT_NAME: 'NAME',
	NATIONAL: 'NATIONAL_CODE',
	UNIT_PHONE: 'PHONE',
};

export const TYPE_SEARCH_UNIT_OPTIONS = [
	{
		value: SearchType.UNIT_NAME,
		label: '사업체',
	},
	{
		value: SearchType.NATIONAL,
		label: '국가',
	},
	{
		value: SearchType.UNIT_PHONE,
		label: '사업체 전화번호',
	},
];
